const API_URL = process.env.REACT_APP_API_URL || 'https://api.synapso.cz';

export const api = {
  async getPrices() {
    const response = await fetch(`${API_URL}/api/prices`);
    return response.json();
  },

  async createCheckoutSession(priceKey, userId, email) {
    const response = await fetch(`${API_URL}/api/create-checkout-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ priceKey, userId, email }),
    });
    return response.json();
  },

  async getSubscription(userId) {
    const response = await fetch(`${API_URL}/api/subscription/${userId}`);
    return response.json();
  },

  async createPortalSession(customerId, email) {
    const response = await fetch(`${API_URL}/api/create-portal-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ customerId, email }),
    });
    return response.json();
  },

  // ===============================
  // REFERRAL API
  // ===============================

  async getReferralCode(userId) {
    const response = await fetch(`${API_URL}/api/referral/code/${userId}`);
    return response.json();
  },

  async getReferralStats(userId) {
    const response = await fetch(`${API_URL}/api/referral/stats/${userId}`);
    return response.json();
  },

  async validateReferralCode(code) {
    const response = await fetch(`${API_URL}/api/referral/validate/${code}`);
    return response.json();
  },

  async applyReferralCode(referralCode, referredUserId) {
    const response = await fetch(`${API_URL}/api/referral/apply`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ referralCode, referredUserId }),
    });
    return response.json();
  },

  async getCheckoutDiscount(userId) {
    const response = await fetch(`${API_URL}/api/referral/checkout-discount/${userId}`);
    return response.json();
  },

  // ===============================
  // AFFILIATE API
  // ===============================

  async getAffiliateStatus(userId) {
    const response = await fetch(`${API_URL}/api/affiliate/status/${userId}`);
    return response.json();
  },

  async getAffiliateStats(userId) {
    const response = await fetch(`${API_URL}/api/affiliate/stats/${userId}`);
    return response.json();
  },

  async setAffiliateStatus(userId, isAffiliate, commissionRate = 20) {
    const response = await fetch(`${API_URL}/api/affiliate/set-status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, isAffiliate, commissionRate }),
    });
    return response.json();
  },

  async trackAffiliateClick(code) {
    const response = await fetch(`${API_URL}/api/affiliate/track-click`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ code }),
    });
    return response.json();
  },

  async getAffiliateCommissions(userId) {
    const response = await fetch(`${API_URL}/api/affiliate/commissions/${userId}`);
    return response.json();
  },

  // Payout settings
  async getPayoutSettings(userId) {
    const response = await fetch(`${API_URL}/api/affiliate/payout-settings/${userId}`);
    return response.json();
  },

  async updatePayoutSettings(userId, settings) {
    const response = await fetch(`${API_URL}/api/affiliate/payout-settings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, ...settings }),
    });
    return response.json();
  },

  async requestPayout(userId) {
    const response = await fetch(`${API_URL}/api/affiliate/request-payout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId }),
    });
    return response.json();
  },

  async getPayoutHistory(userId) {
    const response = await fetch(`${API_URL}/api/affiliate/payouts/${userId}`);
    return response.json();
  },

  // ===============================
  // PROMO CODES API
  // ===============================

  async validatePromoCode(code) {
    const response = await fetch(`${API_URL}/api/promo/validate/${code}`);
    return response.json();
  },

  async redeemPromoCode(code, userId) {
    const response = await fetch(`${API_URL}/api/promo/redeem`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ code, userId }),
    });
    return response.json();
  },
};
